import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { formatDocumentTitle } from '@/lib/document-title';
import { MenuImportReviewPage } from './services/menu-import/review/menu-import-review-page';

/**
 * Review an AI-imported service menu — `/settings/services/import`. The trailing `_` in `services_`
 * makes it its own full page instead of nesting inside the Services settings layout.
 */
export const Route = createFileRoute('/_auth/$orgId/settings/services_/import')({
  component: ServicesImportRoute,
});

function ServicesImportRoute() {
  const { orgId } = Route.useParams();
  return (
    <>
      <Helmet>
        <title>{formatDocumentTitle('Review your menu')}</title>
      </Helmet>
      {/* Keyed by salon: switching salon must never keep the previous salon's pinned draft. */}
      <MenuImportReviewPage key={orgId} routeOrgId={orgId} />
    </>
  );
}
